import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import * as Sentry from "@sentry/react";

const environments = () => {
  const url = window.location.href;

  let env = "production";
  if (url.includes(".tst")) {
    env = "testing";
  }
  if (url.includes(".acc")) {
    env = "acceptance";
  }
  if (url.includes("localhost")) {
    env = "local";
  }
  return env;
};

Sentry.init({
  dsn: "https://644bdd88d5351dbe048a72febf73d9df@o164212.ingest.us.sentry.io/4511744179437568",
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  },
  environment: environments(),
});
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Suspense fallback={<div />}>
      <App />
    </Suspense>
  </React.StrictMode>,
);
